import React, {useState} from "react"
import {Controller, useForm} from "react-hook-form";
import {EditClientCoachNote} from "../../../services/coaching.service";
import {Col, notification, Row} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {Form} from "react-bootstrap";
import {checkEmptySpaces, maxLength, Required} from "../../../utils/patterns";
import DescriptionInput from "../../../components/common/description-field/DescriptionField";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {useNavigate, useParams} from "react-router-dom";

export default function EditCoachNote({open, close, clientData, setClientData}) {
    let { id } = useParams();
    let navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [renderContent, setRenderContent] = useState(false);
    const [loader,setLoader] = useState(false)
    const {
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
        control,
        clearErrors,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const onSubmit = async (data) => {
        setLoader(true)
        let payload = {
            clientId: clientData.clientId,
            coachNote: data?.coach_note,
        };
        try {
            let res = await EditClientCoachNote(payload);
            if (res?.data?.data?.status) {
                notification.success({
                    message: "Success",
                    description: res?.data?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck />,
                    duration: 2,
                });
                // Update the coach note in the state
                setClientData((prevState) => ({
                    ...prevState,
                    coachNote: payload.coachNote, // Update the coachNote key
                }));
                close(false)
            }
        } catch (error) {
            console.log("ThisIsErr", error);
            console.log("ThisIsErr2", error?.response);
        } finally {
            // setSessionEdit(null);
            // setRenderContent(!renderContent);
            // reset();
            // setLoader(false)
            // navigate(`/coaching/client-details/${id}`)
        }
    };
    return(
        <div>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="main_div_client_details">
                    <Row gutter={[16, 16]}>
                            <Col xs={24} lg={24} xl={24} md={24}>
                                <div className="col_1_div">
                                    <div className="inner_div_col_1">
                                        <div className="form_div">
                                            {/*<h5>Coach Note</h5>*/}
                                            <div className={"dfields"}>
                                                <Controller
                                                    name="coach_note"
                                                    defaultValue={clientData?.coachNote ? clientData?.coachNote : '' }
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(10000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        <DescriptionInput
                                                            rows={10}
                                                            autoSize={{ minRows: 10, maxRows: 11 }}
                                                            placeholder={"Write your coaching notes here..."}
                                                            label={"Coach Note"}
                                                            type={"text"}
                                                            field={field}
                                                            errors={errors.coach_note}
                                                            className={"required"}
                                                            defaultValue={clientData?.coachNote ? clientData?.coachNote : '' }
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className={"dfields mt-3"}>
                                    <ThemeButton
                                        text={"Submit"}
                                        className={"btn-light-lg"}
                                        type={"submit"}
                                        loader={loader}
                                    />
                                </div>
                            </Col>
                        </Row>
                </div>
            </Form>
        </div>
    )
}